import { jsx as _jsx } from "react/jsx-runtime";
import { PrivyProvider } from '@privy-io/react-auth';
import { createSolanaRpc, createSolanaRpcSubscriptions } from '@solana/kit';
import { useEffect, useMemo } from 'react';
import { privyAdapter } from '../../adapter';
import { SOLANA_RPC_SUBSCRIPTION_URL, SOLANA_RPC_URL } from './SocialWalletProvider.constants';
import { convertMetaChainsToPrivySupportedChains } from './SocialWalletProvider.utils';
export function SocialWalletProvider(props) {
    const { appId, children, supportedChains, appearance } = props;
    useEffect(() => {
        privyAdapter.setSupportedChains(supportedChains);
    }, [supportedChains]);
    const convertedSupportedChains = useMemo(() => {
        return convertMetaChainsToPrivySupportedChains(supportedChains);
    }, [supportedChains]);
    return (_jsx(PrivyProvider, { appId: appId, config: {
            appearance,
            solana: {
                rpcs: {
                    'solana:mainnet': {
                        rpc: createSolanaRpc(SOLANA_RPC_URL),
                        rpcSubscriptions: createSolanaRpcSubscriptions(SOLANA_RPC_SUBSCRIPTION_URL),
                    },
                },
            },
            embeddedWallets: {
                ethereum: {
                    createOnLogin: 'all-users',
                },
                solana: {
                    createOnLogin: 'all-users',
                },
            },
            externalWallets: {
                disableAllExternalWallets: true,
            },
            loginMethods: ['email', 'google', 'twitter'],
            ...(convertedSupportedChains && convertedSupportedChains.length > 0
                ? { supportedChains: convertedSupportedChains }
                : {}),
        }, children: children }));
}
